<template>
  <div class="result-container">
    <h1>RacingMax</h1>
    <h2>
      QBE Motor Cycle Insurance System
    </h2>
    <el-button
      size="small"
      class="btn-home"
      @click="$router.replace('/')"
    >
      Home
    </el-button>
    
    <div class="result-box">
      <h2>Search Results</h2>
      <el-table
        :data="tableData"
        style="width: 100%"
        @row-click="rowClick"
      >
        <el-table-column
          prop="created_date"
          label="Created Date"
        />
        <el-table-column
          prop="account"
          label="Account"
        />
        <el-table-column
          prop="rgtn_no"
          label="Registration Number"
        />
        <el-table-column
          prop="id_no"
          label="HKID Number"
        />
        <el-table-column
          prop="cvr_nt_no"
          label="Cover Note Number"
        />
        <el-table-column
          prop="pcy_no"
          label="Policy Number"
        />
        <el-table-column
          prop="lock"
          label="Lock"
        />
        <el-table-column
          prop="void"
          label="Void"
        />
      </el-table>
    </div>
    <v-pagination 
      :pageSize="pageConfig.pageSize" 
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </div>
</template>
<script>
import { getPolicyList } from '@/api'
import { mapActions } from 'vuex'
import VPagination from '@/components/control/v-pagination'
export default {
  name: 'Policy',
  components: {
    VPagination
  },
  data() {
    return {
      pageConfig: {
        pageSize: 2,
        currentPage: 1,
        total: 10
      },
      tableData: []
    }
  },
  created() {
    this.handlerGetData()
  },
  methods: {
    ...mapActions('policy', ['setPolicyForm', 'setPolicyId']),
    rowClick(row) {
      this.setPolicyForm(null) // 初始化
      this.setPolicyId('')
      this.$router.push({
        path: '/application',
        query: {
          policyId: row.id
        }
      })
    },
    handlerGetData() {
      const { rgtn_no, mobile_no, id_no, cvr_nt_no, pcy_no, issue_dt } = this.$route.query
      this.network().getPolicyList({
        rgtn_no,
        mobile_no,
        id_no,
        cvr_nt_no,
        pcy_no,
        issue_dt
      })
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.handlerGetData()
    },
    network() {
      return {
        getPolicyList: async (params) => {
          const { data } = await getPolicyList({
            ...params,
            page: this.pageConfig.currentPage,
            // page_size: this.pageConfig.pageSize
          })
          this.tableData = data.data.data
          this.pageConfig.total = data.data.total
          this.pageConfig.pageSize = data.data.per_page
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.result-container {
    padding: 40px;
    // .btn-home {
    //   position: absolute;
    //   top: 50px;
    //   right: 100px;
    // }
    & /deep/ .el-table__row {
      cursor: pointer;
    }
    h1 {
            font-size: 32px;
        }
        h2 {
          margin-bottom: 10px;
            font-size: 24px;
        }
        .result-box {
            margin-top: 30px;
            h2 {
                margin-bottom: 20px;
                color: #616266;
            }
        }
}
</style>